import useSWR, { mutate } from "swr";
import useFetchApi from "hooks/useFetchApi";
import { stringifyQueryParams } from "functions";

const SIMULATION_QUERY_PARAMS = {
  populate: {
    client: { fields: ["id"] },
    documents: {
      fields: [
        "nom",
        "type",
        "taille",
        "updatedAt",
        "antivirus_status",
        "antivirus_threats",
      ],
    },
  },
};

function getSimulationUrl(simulationId) {
  return `simulations/${simulationId}?${stringifyQueryParams(SIMULATION_QUERY_PARAMS)}`;
}

export function mutateSimulation(simulationId) {
  return mutate(getSimulationUrl(simulationId));
}

export default function useSimulation(simulationId) {
  const [fetchApi] = useFetchApi();
  return useSWR(getSimulationUrl(simulationId), fetchApi);
}
